<!--
/*******************************************************************************
*@ 컴포넌트명   : SelectDesc.vue
*@ 컴포넌트설명 : selectbox - option에 사용되는 template (Description 추가)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <slot name="text" />
    <span class="date" v-if="data.date">{{data.date}}</span>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
};
</script>